import ajv from '@f/validation/ajv'
import * as GiftSchema from '@f/validation/schema/datalayer/gift'
import { IGiftAction, IGiftCanceled, IGiftShared } from '@f/validation/types/dataLayer'

export const validateOpenGiftFlow = ajv.compile<IGiftAction>(GiftSchema.OpenGiftFlowSchema)
export const validateGiftStart = ajv.compile<IGiftAction>(GiftSchema.GiftStartSchema)
export const validateGiftCanceled = ajv.compile<IGiftCanceled>(GiftSchema.GiftCanceledSchema)
export const validateGiftShared = ajv.compile<IGiftShared>(GiftSchema.GiftSharedSchema)